document.addEventListener('DOMContentLoaded', () => {
  // Product page accordion JS start
  const accordions = document.querySelectorAll('.product__accordion details');
  const DURATION = 900;
  const EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';
  const MAX_HEIGHT = 300; // max height in px

  accordions.forEach(details => {
    const content = details.querySelector('.accordion__content');
    if (!content) return;

    // Setup base styles
    Object.assign(content.style, {
      overflow: details.open ? 'visible' : 'hidden',
      height: details.open ? 'auto' : '0',
      opacity: details.open ? '1' : '0',
      transform: details.open ? 'translateY(0)' : 'translateY(4px)',
      transition: `height ${DURATION}ms ${EASING}, opacity ${DURATION}ms ${EASING}, transform ${DURATION}ms ${EASING}`,
      willChange: 'height, opacity, transform',
    });

    details.addEventListener('toggle', () => {
      if (details.open) {
        openAccordion(details, content);

        // Close others
        accordions.forEach(other => {
          if (other !== details && other.open) {
            other.open = false;
            closeAccordion(other, other.querySelector('.accordion__content'));
          }
        });
      } else {
        closeAccordion(details, content);
      }
    });
  });

  function openAccordion(details, content) {
    content.style.display = 'block';
    content.style.overflow = 'hidden'; // freeze overflow while animating

    const startHeight = content.offsetHeight;
    const fullHeight = content.scrollHeight;
    const endHeight = Math.min(fullHeight, MAX_HEIGHT); // respect max height

    // Start from current height
    content.style.height = startHeight + 'px';
    content.offsetHeight; // force reflow

    requestAnimationFrame(() => {
      content.style.transition = `height ${DURATION}ms ${EASING}, opacity ${DURATION}ms ${EASING}, transform ${DURATION}ms ${EASING}`;
      content.style.height = endHeight + 'px';
      content.style.opacity = '1';
      content.style.transform = 'translateY(0)';
    });

    // After animation ends
    setTimeout(() => {
      if (details.open) {
        content.style.height = 'auto'; // allow natural height for smaller content
        content.style.maxHeight = MAX_HEIGHT + 'px'; // enforce max height for tall content
        content.style.overflowY = fullHeight > MAX_HEIGHT ? 'auto' : 'visible'; // scroll if too tall
        content.style.overflowX = 'hidden';
      }
    }, DURATION + 50);
  }

  function closeAccordion(details, content) {
    const startHeight = content.scrollHeight;

    content.style.height = startHeight + 'px';
    content.offsetHeight; // force reflow

    requestAnimationFrame(() => {
      content.style.transition = `height ${DURATION}ms ${EASING}, opacity ${DURATION}ms ${EASING}, transform ${DURATION}ms ${EASING}`;
      content.style.height = '0';
      content.style.opacity = '0';
      content.style.transform = 'translateY(4px)';
      content.style.overflow = 'hidden';
    });
  }
  // Product page accordion JS end

  // Fecth media review from review app start
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    } else {
      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          callback(el);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // waitForElement(".stamped-content .stamped-review", function(el) {
  //   // console.log('111111111111111111111111');
  //   const pdp_reviews = Array.from(document.querySelectorAll(".stamped-review"));
  //   const fiveStarReview = pdp_reviews.find(el => el.getAttribute("data-rating") === "5");

  //   if (fiveStarReview) {
  //     // console.log("fiveStarReview:-", fiveStarReview);
  //     const content = fiveStarReview.querySelector(".stamped-review-content-body")?.innerText.trim() || "";
  //     const author = fiveStarReview.querySelector(".stamped-review-header .author")?.innerText.trim() || "";
  //     const hasVerifiedBadge = fiveStarReview.querySelector(".stamped-verified-badge") !== null;

  //     // Target custom elements
  //     const pmgBody = document.querySelector(".pmg-review .pmg-review__body");
  //     const pmgAuthor = document.querySelector(".pmg-review .pmg-review__footer .author-name");
  //     const pmgVerified = document.querySelector(".pmg-review .pmg-review__footer .pmg-verified");

  //     if (pmgBody) pmgBody.textContent = content;
  //     if (pmgAuthor) pmgAuthor.textContent = author;
  //     if (pmgVerified && !hasVerifiedBadge) pmgVerified.classList.add("not-verify");
  //   }
  // });
  // Fecth media review from review app end


  var picker = document.querySelector('variant-selects');
  var variants = null;
  var variantJSONscript = null;

  // Only get variants if variant-selects exists (products with variants)
  if (picker) {
    variantJSONscript = picker.querySelector('script[type="application/json"]') || document.querySelector('script[type="application/json"]');
    if (variantJSONscript) {
      try {
        variants = JSON.parse(variantJSONscript.textContent);
      } catch (e) {
        variants = null;
      }
    }
  }

  function getSelectedValue(optionName) {
    if (!picker) return null;
    var inputs = picker.querySelectorAll('[name^="options[' + optionName + ']"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return inputs[i].value;
    }
    var sel = picker.querySelector('select[name^="options[' + optionName + ']"]');
    if (sel && sel.value) return sel.value;
    return null;
  }

  function getCurrentOptions() {
    if (!picker) return [];
    var opts = [];
    var allFieldsets = picker.querySelectorAll('.product-form__input');
    allFieldsets.forEach(fieldset => {
      var nameEl = fieldset.querySelector('input, select');
      if (!nameEl) return;
      var nameMatch = nameEl.name.match(/options\[(.*?)\]/);
      var name = nameMatch && nameMatch[1];
      if (!name) return;
      var val = getSelectedValue(name);
      opts.push(val);
    });
    return opts;
  }

  function getActiveVariant() {
    if (!picker || !variants) return null;

    var optionVals = getCurrentOptions();
    if (!optionVals || !optionVals.length) return null;

    optionVals = optionVals.filter(Boolean);

    return variants.find(function (variant) {
      return (
        variant.options.length === optionVals.length &&
        variant.options.every(function (optionValue, index) {
          return optionValue == optionVals[index];
        })
      );
    }) || null;
  }

  function variantMatchesOptionValues(variant, optionValues) {
    if (!variant || !optionValues || !optionValues.length) return false;
    if (variant.options.length !== optionValues.length) return false;
    for (var i = 0; i < optionValues.length; i++) {
      if (variant.options[i] != optionValues[i]) return false;
    }
    return true;
  }

  function buildOptionValuesWithQuantity(inputValue) {
    var optionVals = getCurrentOptions().slice();
    var allLegends = Array.from(picker.querySelectorAll('.product-form__input legend')).map(function (l) {
      return l.textContent.trim();
    });
    var qtyLabelIndex = allLegends.findIndex(function (lbl) {
      return lbl.toLowerCase().includes('quantity');
    });
    if (qtyLabelIndex > -1) optionVals[qtyLabelIndex] = inputValue;
    return optionVals.filter(Boolean);
  }

  function updatePricePerCount() {
    if (!picker || !variants) return;
    var currentVariant = getActiveVariant();
    var subscriptionRatio = null;
    if (window.currentSubscriptionPrice && currentVariant && currentVariant.price > 0) {
      subscriptionRatio = window.currentSubscriptionPrice / currentVariant.price;
    }

    // ── Current potency ka 10 count variant JS se dhundo ──
    var tenCountPrice = 0;
    if (currentVariant) {
      var tenVariant = variants.find(function(v) {
        // Quantity option ko ignore karo, baaki sab options match karo
        var quantityOptions = ['10 count', '30 count', '20 count', '60 count'];
        var currentNonQty = {};
        var vNonQty = {};

        ['option1', 'option2', 'option3'].forEach(function(opt) {
          var curVal = currentVariant[opt];
          var vVal = v[opt];
          if (curVal && !quantityOptions.includes(curVal.toLowerCase())) {
            currentNonQty[opt] = curVal;
          }
          if (vVal && !quantityOptions.includes(vVal.toLowerCase())) {
            vNonQty[opt] = vVal;
          }
        });

        // Potency match karo
        var potencyMatch = JSON.stringify(currentNonQty) === JSON.stringify(vNonQty);

        // Ye variant 10 count ka hona chahiye
        var isTen = ['option1', 'option2', 'option3'].some(function(opt) {
          return v[opt] && v[opt].toLowerCase() === '10 count';
        });

        return potencyMatch && isTen;
      });

      if (tenVariant) {
        tenCountPrice = tenVariant.price;
      }
    }

    var pills = document.querySelectorAll('.variant-pills__item input[data-variant-id][data-qty]');
    pills.forEach(function (input) {
      var qty = parseInt(input.getAttribute('data-qty'), 10);
      if (!qty || isNaN(qty) || qty <= 0) qty = 1;
      var parentLabel = input.closest('label.variant-pill') || input.parentElement.querySelector('label.variant-pill') || input.parentElement;
      var optionVals = buildOptionValuesWithQuantity(input.value);

      var variantMatch = variants.find(function (v) {
        return variantMatchesOptionValues(v, optionVals);
      });

      if (!variantMatchesOptionValues(variantMatch, optionVals)) {
        variantMatch = variants.find(function (v) {
          return variantMatchesOptionValues(v, optionVals);
        });
      }

      if (!variantMatch) return;

      var priceCents;
      if (subscriptionRatio !== null) {
        priceCents = Math.round(variantMatch.price * subscriptionRatio);
      } else if (window.currentSubscriptionPrice) {
        priceCents = window.currentSubscriptionPrice;
      } else {
        priceCents = variantMatch.price;
      }

      var span = parentLabel.querySelector('.variant-pill__price-tag');
      if (!span) return;

      // ── Savings calculate karo ──
      if (qty > 10) {
        var savings = 0;

        if (subscriptionRatio !== null) {
          // Subscribe: original price - subscription price
          savings = variantMatch.price - priceCents;
        } else {
          // One-time: (10 count price × 3) - 30 count price
          if (tenCountPrice > 0) {
            savings = (tenCountPrice * 3) - variantMatch.price;
          }
        }

        if (savings > 0) {
          var savingsFormatted = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
            ? Shopify.formatMoney(savings, '{{amount}}')
            : '$' + (savings / 100).toFixed(2);
          span.textContent = 'Save ' + savingsFormatted;
          return;
        }
      }

      // ── 10 count: price/each dikhao ──
      // var pricePer = priceCents / qty;
      // var formatted = (typeof Shopify !== 'undefined' && Shopify.formatMoney)
      //   ? Shopify.formatMoney(pricePer, '{{amount_no_decimals}}')
      //   : (pricePer / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      // span.textContent = formatted + '/each';
    });
  }
  // Only add event listener if picker exists (products with variants)
  
  if (picker) {
    picker.addEventListener('change', function (e) {
      if (!e.target.closest('.product-form__input')) return;

      setTimeout(function () {
        updatePricePerCount();
        updateMainPriceDisplay();
      }, 0);
    });
  }

  // === Listen to variant change events ===
  var variantChangeUnsubscriber = null;
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {
        // Update price when variant changes
        updateMainPriceDisplay(event.data.variant);
        updatePricePerCount();
      }
    });
  }

  // === Watch for Loop Subscription updates ===
  function handleLoopChange() {
    const selectedOption = document.querySelector('.loop-widget-purchase-option.loop-widget-purchase-option-selected');
    
    // Check if the selected option is a subscription (must not be one-time)
    let isSubscriptionSelected = false;
    if (selectedOption) {
      // 1. Check if the selected radio button is for subscription
      const radio = selectedOption.querySelector('input[type="radio"]');
      if (radio) {
        const val = radio.value.toLowerCase();
        if (val && val !== 'one-time' && val !== 'one_time' && val !== 'single' && val !== 'onetime' && val !== 'single-purchase' && val !== 'single_purchase') {
          isSubscriptionSelected = true;
        }
      }
      
      // 2. Fallback/Reinforcement checks if no radio value was decisive
      if (!isSubscriptionSelected) {
        const text = selectedOption.textContent.toLowerCase();
        const hasSelect = selectedOption.querySelector('select') !== null;
        const hasSellingPlanInput = selectedOption.querySelector('input[name="selling_plan"], [name^="selling_plan"]') !== null;
        const hasSubClass = selectedOption.classList.contains('loop-subscription-purchase-option') || 
                            selectedOption.classList.contains('loop-auto-ship-purchase-option');
        
        if (hasSelect || hasSellingPlanInput || hasSubClass || text.includes('subscribe') || text.includes('save 25%') || text.includes('frequency')) {
          isSubscriptionSelected = true;
        }
      }
    }

    if (isSubscriptionSelected) {
      let priceText = '';
      let priceEl = selectedOption.querySelector('.loop-widget-purchase-option-price') ||
                    selectedOption.querySelector('.loop-purchase-option-price') ||
                    selectedOption.querySelector('.loop-price') ||
                    selectedOption.querySelector('[class*="price"]');
      if (priceEl) {
        priceText = priceEl.textContent.trim();
      } else {
        // Fallback: extract the price from the entire option text
        const match = selectedOption.textContent.match(/\$\s*(\d+(?:\.\d{2})?)/);
        if (match) {
          priceText = match[1];
        }
      }

      const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (!isNaN(priceValue)) {
        window.currentSubscriptionPrice = priceValue * 100; // convert to cents
        updateMainPriceDisplay();
      }
    } else {
      window.currentSubscriptionPrice = null;
      updateMainPriceDisplay(); // Update to show regular price when subscription is deselected
    }
    updatePricePerCount();

    console.log('Loop Widget Change Processed:', {
      selectedOption,
      isSubscriptionSelected,
      currentSubscriptionPrice: window.currentSubscriptionPrice
    });
  }

  function setupLoopObserver(loopContainer) {
    if (loopContainer._hasObserver) return;
    loopContainer._hasObserver = true;

    const observer = new MutationObserver(() => {
      handleLoopChange();
      setTimeout(handleLoopChange, 50);
      setTimeout(handleLoopChange, 150);
    });

    observer.observe(loopContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });

    // Run multiple times during load/initialization to catch the final state of widget
    handleLoopChange();
    setTimeout(handleLoopChange, 100);
    setTimeout(handleLoopChange, 300);
    setTimeout(handleLoopChange, 600);
    setTimeout(handleLoopChange, 1200);
  }

  function initLoopObserver() {
    const getLoopContainer = () => {
      return document.querySelector('.loop-widget-container') ||
             document.querySelector('.loop-widget') ||
             document.querySelector('.loop-subscription-widget') ||
             document.querySelector('[data-loop-widget]') ||
             document.querySelector('[data-loop-widget-selling-plan-group]');
    };

    const loopContainer = getLoopContainer();
    if (loopContainer) {
      setupLoopObserver(loopContainer);
    }

    // Setup a body observer to detect loop widget insertion or replacement
    const bodyObserver = new MutationObserver(() => {
      const currentContainer = getLoopContainer();
      if (currentContainer && !currentContainer._hasObserver) {
        setupLoopObserver(currentContainer);
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initLoopObserver();

  // Fallback click/change listener to handle immediate interaction updates
  document.addEventListener('click', (e) => {
    if (e.target.closest('.loop-widget-container') || e.target.closest('[data-loop-widget]') || e.target.closest('.loop-widget')) {
      setTimeout(handleLoopChange, 50);
      setTimeout(handleLoopChange, 150);
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.closest('.loop-widget-container') || e.target.closest('[data-loop-widget]') || e.target.closest('.loop-widget')) {
      setTimeout(handleLoopChange, 50);
      setTimeout(handleLoopChange, 150);
    }
  });

  // Store original product price for products without variants
  var originalProductPrice = null;
  function getOriginalProductPrice() {
    if (originalProductPrice) return originalProductPrice;

    // FALL SALE: the displayed price is already the 35% price, so read the real price from the server attribute
    var fallSaleWrap = document.querySelector('.product__price .price[data-original-price]');
    if (fallSaleWrap) {
      var fsOriginal = parseInt(fallSaleWrap.getAttribute('data-original-price'), 10);
      if (!isNaN(fsOriginal) && fsOriginal > 0) {
        originalProductPrice = fsOriginal;
        return originalProductPrice;
      }
    }

    // Scope to main product price only, so collection card prices are not affected
    var priceEls = document.querySelectorAll(
      '.product__price .price__regular .price-item--regular, .product__price .price__sale .price-item--sale'
    );
    if (priceEls.length > 0) {
      var currentPriceText = priceEls[0].textContent.trim();
      var priceMatch = currentPriceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        var priceValue = parseFloat(priceMatch[0].replace(/,/g, ''));
        if (!isNaN(priceValue)) {
          originalProductPrice = Math.round(priceValue * 100);
          return originalProductPrice;
        }
      }
    }
    return null;
  }

  // Only update price per count if picker exists (products with variants)
  if (picker) {
    updatePricePerCount();
  }
  // Store original price on page load
  getOriginalProductPrice();
  updateMainPriceDisplay(); // Initial price update
  // === End AI dynamic price-per-count ===

  function updateMainPriceDisplay(variantFromEvent) {
    // Get current variant price
    var currentVariant = variantFromEvent || null;

    // If variant not provided from event, try to get it from variant-selects element
    if (!currentVariant && picker) {
      var variantSelects = document.querySelector('variant-selects');
      if (variantSelects && variantSelects.currentVariant) {
        currentVariant = variantSelects.currentVariant;
      }
    }

    // If still no variant, try to find it from options (for products with variants)
    if (!currentVariant && picker && variants) {
      var currentOptions = getCurrentOptions();
      if (currentOptions) {
        var optionVals = currentOptions.slice();
        var allLegends = Array.from(picker.querySelectorAll('.product-form__input legend')).map(l => l.textContent.trim());
        var qtyLabelIndex = allLegends.findIndex(lbl => lbl.toLowerCase().includes('quantity'));
        if (qtyLabelIndex > -1) {
          // Get the selected quantity value
          var qtyInput = picker.querySelector('.variant-pills__item input[data-variant-id][data-qty]:checked');
          if (qtyInput) {
            optionVals[qtyLabelIndex] = qtyInput.value;
          }
        }
        optionVals = optionVals.filter(Boolean);
        currentVariant = variants.find(v => v.options.length === optionVals.length && v.options.every((vo, i) => vo == optionVals[i]));
      }
    }

    // Determine which price to use
    var priceCents = null;
    if (window.currentSubscriptionPrice) {
      // Use subscription price if available
      priceCents = window.currentSubscriptionPrice;
    } else if (currentVariant) {
      // Use variant price (for products with variants)
      priceCents = currentVariant.price;
    } else {
      // For products without variants, use original product price
      priceCents = getOriginalProductPrice();

      // If still no price found, don't update
      if (!priceCents) return;
    }

    if (!priceCents) return;

    // Update price display, scoped to the main product price wrapper only
    var priceEls = document.querySelectorAll(
      '.product__price .price__regular .price-item--regular, .product__price .price__sale .price-item--sale'
    );
    if (!priceEls.length) return;

    // FALL SALE: 35% off one-time purchases only (subscription price is shown as is).
    // Flag comes from snippets/price.liquid (data-fall-sale), so excluded products (gift card) are skipped.
    var fallSaleWrap = document.querySelector('.product__price .price[data-fall-sale]');
    var useFallSale = !!fallSaleWrap && !window.currentSubscriptionPrice;
    var originalCents = priceCents;
    // one-time (non-subscription) price of the selected variant, used for the Loop widget's one-time option
    var oneTimeBaseCents = currentVariant ? currentVariant.price : getOriginalProductPrice();
    if (useFallSale) {
      priceCents = Math.floor((originalCents * 65 + 99) / 100); // 65% of price, rounded up
    }

    // Convert price from cents to formatted currency
    var formatMoneyCents = function (cents) {
      return (typeof Shopify !== 'undefined' && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, "{{amount_no_decimals}}")
        : (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    var formatted = formatMoneyCents(priceCents);

    priceEls.forEach(function (el) {
      el.textContent = formatted;
    });

    if (fallSaleWrap) {
      // One-time: strike the regular price next to the 35% price (+ "Save 35%" badge).
      // Subscription: strike the regular one-time price next to the subscription price, badge hidden (35% does not apply).
      document.querySelectorAll('.product__price .price__sale s.price-item--regular').forEach(function (el) {
        var holder = el.closest('.price-item--last') || el;
        var strikeCents = useFallSale ? originalCents : oneTimeBaseCents;
        if (strikeCents) {
          el.textContent = formatMoneyCents(strikeCents);
          holder.style.display = '';
        } else {
          holder.style.display = 'none';
        }
        holder.querySelectorAll('.fall-sale-badge').forEach(function (badge) {
          badge.style.display = useFallSale ? '' : 'none';
        });
      });

      // Loop widget "One-time purchase" option should show the same 35% price.
      // Only write when the text actually changes, otherwise the Loop MutationObserver would loop forever.
      if (oneTimeBaseCents) {
        var oneTimeSaleText = formatMoneyCents(Math.floor((oneTimeBaseCents * 65 + 99) / 100));
        document.querySelectorAll('.loop-widget-purchase-option-onetime .loop-widget-purchase-option-price').forEach(function (el) {
          if (el.textContent.trim() !== oneTimeSaleText) {
            el.textContent = oneTimeSaleText;
          }
        });
      }
    }
  }

  if (window.location.href.indexOf("harmonious-exploration-meta-bundle") !== -1) {
    var hideEl = function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.style.display = 'none'; });
    };
    hideEl("#shopify-section-sections--26072568463636__announcement-bar");
    setTimeout(function () {
      hideEl(".needsclick.kl-teaser-RE6sLC.kl-private-reset-css-Xuajs1");
    }, 2000);
  }

  // === Listen to variant change events for Metafield Updates ===
  var variantMetafields = null;

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {

        // Parse metafields data if not already parsed
        if (!variantMetafields) {
          var metafieldScript = document.getElementById('variant-metafields');
          if (metafieldScript) {
            try {
              variantMetafields = JSON.parse(metafieldScript.textContent);
            } catch (e) {
              console.error('Error parsing variant metafields:', e);
            }
          }
        }

        if (variantMetafields && variantMetafields[event.data.variant.id]) {
          var currentMetafields = variantMetafields[event.data.variant.id];
          var accordionWebElements = document.querySelectorAll('.accordion__content[data-mf-key]');

          accordionWebElements.forEach(function (element) {
            var key = element.getAttribute('data-mf-key').trim();
            if (currentMetafields.hasOwnProperty(key)) {
              // Update content, handling null/undefined as empty string
              var newContent = currentMetafields[key] || '';
              // Only update if content is different to avoid unnecessary reflows/flickers
              if (element.innerHTML !== newContent) {
                // Check if the content is a file path (simple check for extension) or HTML
                if (typeof newContent === "string" && newContent.trim() === "") {
                  // Keep original or empty? based on logic, likely empty if variant specific
                  element.innerHTML = "";
                } else {
                  element.innerHTML = newContent;
                }
              }
            }
          });
        }
      }
    });

  }

});

